import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router'

// 页面集合 
import download from '../views/one.vue';
import at from '../views/at.vue';
import atPlus from '../views/atPlus.vue';
import doctor from '../views/doctor.vue'; //合何医生
import freone from '../views/freone.vue'; 
import g9 from '../views/g9.vue';
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path:'/',
      component: download,
      meta: {
        title: 'APP下载'
      }
    },
    {
      path: '/download',
      name: 'download',
      component: download,
      meta: {
        title: 'APP下载'
      }
    },
    {
      path: '/download/doctor',
      name: 'doctor',
      component: doctor,
      meta: {
        title: '合卫医生APP下载'
      }
    },
    {
      path: '/download/at',
      name: 'at',
      component: at,
      meta: {
        title: '艾糖APP下载'
      }
    },
    {
      path: '/download/atPlus',
      name: 'atPlus',
      component: atPlus,
      meta: {
        title: '艾糖PlusAPP下载'
      }
    },
    {
      path: '/download/freone',
      name: 'freone',
      component: freone,
      meta: {
        title: '瞬宝FREONE下载'
      }
    },
    {
      path: '/download/g9',
      name: 'g9',
      component: g9,
      meta: {
        title: 'Gluoua艾糖'
      }
    },
  ]
})

export default router
